import { queryClient } from '@/client/query';
import Loading from '@/components/loading/loading';
import useGetMe from '@/queries/me.queries';
import { GetMeResponse } from '@/repositories/me.repository';
import { PropsWithChildren, createContext, useContext } from 'react';

type MeValue = {
  data: GetMeResponse | null | undefined;
  refetch: () => void;
};

const defaultValue = {
  data: {},
  refetch: () => {
    //
  },
} as unknown as MeValue;

const MeContext = createContext<MeValue>(defaultValue);

export function useMe() {
  const context = useContext(MeContext);

  if (!context) {
    throw new Error('useMe must be used within a MeProvider');
  }

  return context;
}

export function MeProvider(props: PropsWithChildren) {
  const { data, isLoading, refetch: refetchMe } = useGetMe();

  function refetch() {
    queryClient.invalidateQueries({ queryKey: ['me', 'get'] }).then(() => refetchMe());
  }

  return isLoading ? <Loading /> : <MeContext.Provider value={{ data, refetch }}>{props.children}</MeContext.Provider>;
}
